import { ChevronRight } from 'lucide-react'
import type { Activity } from '@hewey/shared'
import { ActivityCard } from './ActivityCard.tsx'
import styles from './CollectionRow.module.css'

type Props = {
	title: string
	subtitle?: string | undefined
	activities: Activity[]
	onSeeAll?: (() => void) | undefined
}

// One Explore collection: a heading (with optional "See all" hand-off into the
// results grid) above a single horizontally-scrolling row of feature cards.
export const CollectionRow = ({
	title,
	subtitle,
	activities,
	onSeeAll,
}: Props) => (
	<section className={styles.row}>
		<header className={styles.head}>
			<div className={styles.heading}>
				<h2 className={styles.title}>{title}</h2>
				{subtitle ? (
					<p className={styles.subtitle}>{subtitle}</p>
				) : null}
			</div>
			{onSeeAll ? (
				<button
					type="button"
					className={styles.seeAll}
					onClick={onSeeAll}
				>
					See all
					<ChevronRight size={16} aria-hidden="true" />
				</button>
			) : null}
		</header>

		<ul className={styles.scroll}>
			{activities.map((a) => (
				<li key={a.id} className={styles.item}>
					<ActivityCard activity={a} />
				</li>
			))}
		</ul>
	</section>
)
